import * as React from 'react';
import LoadingModal from './LoadingModal';

export interface OrderValidatingModalProps {}

const FUN_FACTS = [
  'Visste du att det är fysiskt omöjligt för grisar att titta upp mot himlen – deras nackmuskler tillåter inte rörelsen 🐷',
  'Trots att de ofta kallas "smutsiga" badar grisar i lera för att kyla ner sig, eftersom de inte har svettkörtlar. Och nej, de älskar faktiskt att hålla sina sovplatser rena! 🐷',
  'Precis som människor kan grisar utveckla olika "dialekter" i sina grymtningar beroende på vilken grupp de tillhör och var de växer upp. 🐷',
];

export default function OrderValidatingModal({}: OrderValidatingModalProps) {
  const message = React.useMemo(() => FUN_FACTS[Math.floor(Math.random() * 3)], [FUN_FACTS]);

  return <LoadingModal title="Kontrollerar beställning..." message={message} />;
}
